// 1 minute in milliseconds
const oneMinute = 60000;
const timeUntilDedupeRemoval = 5 * oneMinute;

class ErrorMessageDedupe {
  errors: string[];

  constructor() {
    this.errors = [];
  }

  push(error: string): void {
    this.errors.push(error);
    setTimeout(() => {
      this._remove(error);
    }, timeUntilDedupeRemoval);
  }

  contains(error: string): boolean {
    return this.errors.includes(error);
  }

  _remove(error: string) {
    this.errors = this.errors.filter(err => {
      return error !== err;
    });
  }
}

export const errorMessageDedupe = new ErrorMessageDedupe();

export function createDedupeString(...args: any[]) {
  return args.reduce((prev, curr) => {
    return prev + '' + curr;
  }, '');
}
